import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const Reference = () => {
  const [referenceName, setReferenceName] = useState('');
  const [referenceMobileNumber, setReferenceMobileNumber] = useState('');
  const [referenceType, setReferenceType] = useState('');
  const [referenceCount, setReferenceCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const applicationId = new URLSearchParams(location.search).get('applicationId');
  const customerId    = new URLSearchParams(location.search).get('customerId');

  const resetForm = () => {
    setReferenceName('');
    setReferenceMobileNumber('');
    setReferenceType('');
  };

  const handleSubmit = async () => {
    if (!referenceName || !referenceMobileNumber || !referenceType) {
      setErrorModal(true);
      return;
    }
    setIsLoading(true);
    try {
      await api.post(
        `${base_url}/api/reference/addReference?customerId=${customerId}`,
        { referenceName, referenceMobileNumber, referenceType },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const newCount = referenceCount + 1;
      setReferenceCount(newCount);
      if (newCount < 2) {
        setSuccessModal(true);
        resetForm();
      } else {
        navigate(`/DocumentUpload?applicationId=${applicationId}&customerId=${customerId}`);
      }
    } catch {
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="Reference Details" backPath={`/Nominee?applicationId=${applicationId}&customerId=${customerId}`} />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <div className="app-card">
          <p className="section-title">
            Reference {referenceCount + 1} of 2
          </p>

          <div className="field-group">
            <label className="field-label">Reference Name <span className="field-star">*</span></label>
            <input className="field-input" value={referenceName} onChange={e => setReferenceName(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Mobile Number <span className="field-star">*</span></label>
            <input className="field-input" type="tel" value={referenceMobileNumber} onChange={e => setReferenceMobileNumber(e.target.value)} maxLength={10} />
          </div>

          <div className="field-group">
            <label className="field-label">Reference Type <span className="field-star">*</span></label>
            <select className="field-select" value={referenceType} onChange={e => setReferenceType(e.target.value)}>
              <option value="" hidden>Select Type</option>
              <option value="1">Friend</option>
              <option value="2">Relative</option>
              <option value="3">Colleague</option>
              <option value="4">Other</option>
            </select>
          </div>
        </div>

        <button className="btn-primary-app" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Saving...' : referenceCount === 0 ? 'Save & Add Another' : 'Save & Proceed'}
        </button>
      </div>

      <Modal show={successModal} onHide={() => setSuccessModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Reference saved! Please add one more reference.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setSuccessModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Please fill in all required fields.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setErrorModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Reference;
